import React, { Component } from 'react';
import { connect } from 'react-redux';
import { trueFalseToBoolean } from '../../../utils/helpers.utils';
import { NODE_ENVIRONMENTS as nodeEnv } from '../../../utils/constant.utils';

class ExternalRedirectAuthentication extends Component {
    constructor(props) {
        super();
    }

    componentDidMount() {
        if (trueFalseToBoolean(process.env.REACT_APP_EXTERNAL_REDIRECTION)) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = process.env.REACT_APP_INTERNAL_REDIRECTION_URL;
        }
    }
    render() {
        return (
            <div></div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: (process.env.NODE_ENV === nodeEnv.dev) ? state.userTestHarness : state.oidc.user,
        isOidcLoadingUser: (process.env.NODE_ENV === nodeEnv.dev) ? false : state.oidc.isLoadingUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalRedirectAuthentication);